var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.load_web)?_c('div',{attrs:{"id":"dashboard"}},[_c('SidebarDashboard'),_c('div',{staticClass:"right-part"},[_c('div',{class:{ 'right-part-container' : _vm.currentRouteName }},[_c('router-view')],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }